import { render, staticRenderFns } from "./CreateSection.vue?vue&type=template&id=422fa840&scoped=true&"
import script from "./CreateSection.vue?vue&type=script&lang=js&"
export * from "./CreateSection.vue?vue&type=script&lang=js&"
import style0 from "./CreateSection.vue?vue&type=style&index=0&id=422fa840&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422fa840",
  null
  
)

export default component.exports